<script>
import { Bar } from "vue-chartjs";
export default {
  name: "LineChartYear",
  extends: Bar,
  props: {
    label: {
      type: String
    },
    chartData: {
      type: Array
    },
  //  options: {
    //  type: Object
    //}
  },
  watch:{
    chartData(newChartData){
      let totals = null
       if(newChartData){
        totals = Object.keys(newChartData[0]).reduce((acc, key) => {
           acc[key] = newChartData.map(obj => obj[key]);
             return acc;
            }, {});
      this.renderChart(
        {
          labels: ["Enero", "Febrero", "Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
          datasets: [
          {
        label: "Una vez",
        data: totals.short,
        backgroundColor: 'rgba(211, 47, 47, 0.6)'
          },
          {
        label: "Dos veces",
        data: totals.double,
        backgroundColor: 'rgba(253, 216, 53, 0.6)'
          },
          {
        label: "Sostenido",
        data: totals.long,
        backgroundColor: 'rgba(57, 73, 171, 0.6)'
      }
          ]
        },
        {
            responsive: true,
            maintainAspectRatio: false,
       legend: {
             display: true,
             position: 'top',
         labels: {
             fontColor: 'rgba(0, 0, 0, 0.7)'
    }

  },
  scales: {
    yAxes: [{
      ticks: {
          beginAtZero: true 
        }
    }],
  }
        }
      );
    }
  }
  },
  async mounted() {
   let totals = null;
    if(this.chartData !== undefined){
        totals = Object.keys(this.chartData[0]).reduce((acc, key) => {
           acc[key] = this.chartData.map(obj => obj[key]);
             return acc;
            }, {});
    }
    this.renderChart(
      {
    labels: ["Enero", "Febrero", "Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
    datasets: [
      {
        label: "Una vez",
        data: totals.short,
        backgroundColor: 'rgba(211, 47, 47, 0.6)'
      },
      {
        label: "Dos veces",
        data: totals.double,
        backgroundColor: 'rgba(253, 216, 53, 0.6)'
      },
      {
        label: "Sostenido",
        data: totals.long,
        backgroundColor: 'rgba(57, 73, 171, 0.6)'
      }
    ]
  },
      {
        responsive: true,
      maintainAspectRatio: false,   
      legend: {
        display: true,
        position: 'top',
      labels: {
        fontColor: 'rgba(0, 0, 0, 0.7)'
      }
  },
  scales: {
    yAxes: [{
      ticks: {
          beginAtZero: true 
        }
    }],
  }
      }
    );
  },
}
</script>
<style lang="scss"></style>
